import { render, staticRenderFns } from "./ViewFolders.vue?vue&type=template&id=f75f12a6&scoped=true&"
import script from "./ViewFolders.vue?vue&type=script&lang=ts&"
export * from "./ViewFolders.vue?vue&type=script&lang=ts&"
import style0 from "./ViewFolders.vue?vue&type=style&index=0&id=f75f12a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75f12a6",
  null
  
)

export default component.exports